import { loadProductModal } from "./product-model";

export function openModelOnCollection() {
  const urlParams = new URLSearchParams(window.location.search);
  const productId = urlParams.get('product_id');

  if (productId) {
   //console.log('Auto-opening modal for product:', productId);
    if (typeof loadProductModal === 'function') {
      loadProductModal(productId);
    } else {
      console.warn('loadProductModal() is not available.');
    }
  }
}
